import { GenericHeader } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { useSelector } from 'react-redux';
import { curriculum_manager } from 'utils/constants';
import { Results } from './components';
const RequirementList = props => {
  const model = useSelector(state => state.models.mastery);
  const list = () => ({
    models: model.mastery_requirements,
  })
  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Requirements" subheader="Requirement Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={list}
      title="Requirements"
      name="requirements"
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default RequirementList;
